<template>
  <nav class="k2-tabs" :aria-label="tx('tabs.label')" :style="{ '--n': stages.length }">
    <button
      v-for="s in stages"
      :key="s.key"
      type="button"
      class="k2-tab"
      :data-c="s.tone"
      :data-fk="'tab-' + s.key"
      :aria-pressed="s.key === current ? 'true' : 'false'"
      :aria-current="s.key === current ? 'true' : null"
      @click="$emit('stage', s.key)"
    >
      <span class="k2-tab-i">
        <k2-icon :n="s.icon" :s="24" />
        <i class="k2-tab-n">{{ counts[s.key] || 0 }}</i>
        <i v-if="flags[s.key] === 'new'" class="k2-dot k2-dot--new"></i>
        <i v-else-if="flags[s.key] === 'late'" class="k2-dot k2-dot--late"></i>
      </span>
      <span class="k2-tab-l">{{ $t(s.labelKey) }}</span>
    </button>
  </nav>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import kds2Text from "@/mixins/kds2Text";

// Donji tabovi na uskom ekranu (telefon, tablet uspravno): jedno stanje po ekranu, uz broj i oznaku NOVO / kasni.
export default {
  name: "Kds2Tabs",
  components: { K2Icon },
  mixins: [kds2Text],
  props: {
    stages: { type: Array, required: true },
    current: { type: String, default: "" },
    counts: { type: Object, required: true },
    flags: { type: Object, required: true },
  },
};
</script>
